/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_KnpInputs */



/**
* | output |
* | --- |
* | "KNP (Key Names & Phrases) Manager" |
*
* @param {Signup_Compare_KnpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_knp = /** @type {((inputs?: Signup_Compare_KnpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_KnpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "ru") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "es") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "hi") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
	return /** @type {LocalizedString} */ ("KNP (Key Names & Phrases) Manager")
});